<script setup lang="ts">
import BaseOverlay from '@/overlays/BaseOverlay.vue';

const emit = defineEmits(['close']);

interface Props {
  items: any[];
  title: string;
}

defineProps<Props>();
</script>

<template>
  <BaseOverlay @close="emit('close')" :title="title">
    <template #content>
      <div
        v-for="(item, index) in items"
        :key="index"
        class="inline-flex w-full pb-10 items-center"
      >
        <img
          v-if="item.picture !== null"
          :src="item.picture.source"
          :class="{ '-m-1': index !== 0 }"
          class="w-24 h-24 rounded-full border border-gray-200 mr-10"
          v-optimized="{ src: item.picture.source, size: 'small' }"
        />
        <div
          v-else
          :class="{ '-m-1': index !== 0 }"
          class="w-24 h-24 mr-10 flex items-center justify-center"
        >
          <div class="w-5 h-5 rounded-full bg-black"></div>
        </div>
        <p class="label">
          {{ item.title }}
        </p>
      </div>
    </template>
  </BaseOverlay>
</template>
